export default __webpack_public_path__ + "static/media/philadelphia.63715ae8.png";